// Imports for external libraries go here.
import React, { FC, useState, useEffect } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { SuitesCardProps } from './SuitesCard.types';
import { StyledSuitesCard } from './SuitesCard.styles';
import { Button, Eyebrow, EyebrowEnum, LogoContainer } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { Image } from '@marriott/mi-ui-library';
import { getDirection } from '../../modules/helpers';

// Use named rather than default exports.
export const SuitesCard: FC<SuitesCardProps> = ({
  eyebrow,
  ctaLink,
  title,
  trackingProperties,
  dynamicMedia,
  openInNewTab = false,
  styleclass,
  logo,
  custom_click_track_value,
  isLogoFlagEnabled = false,
}) => {
  const [direction, setDirection] = useState(false);
  useEffect(() => {
    setDirection(getDirection());
  }, []);

  return (
    <StyledSuitesCard
      data-testid="luxury-SuitesCard"
      data-component-name="m-luxury-SuitesCard"
      className={clsx(styleclass, 'color-scheme2')}
    >
      <Button
        isLink
        testId="ui-library-cardVerticalWrapperBtn"
        href={ctaLink}
        target={openInNewTab ? '_blank' : '_self'}
        aria-label={ctaLink}
        trackingProperties={trackingProperties}
        rel={`${openInNewTab ? 'noopener noreferrer' : ''}`}
        className={clsx(
          `${`card-chevron icon-arrow${direction ? '-left' : '-right'}${openInNewTab ? '-external' : ''}`}`
        )}
        custom_click_track_value={custom_click_track_value}
      >
        <div className="suites-card-container">
          <Image
            altText={dynamicMedia?.altText}
            renditions={dynamicMedia?.renditions}
            dynamic={dynamicMedia?.dynamic}
            defaultImageURL={dynamicMedia?.assetPath}
            customClass="suites-image"
            loading="eager"
          />
          <div className="suites-card-content">
            <div className="card-text-wrapper">
              <div className="card-texts p-3 mt-2">
                <div>
                  {logo && isLogoFlagEnabled && (
                    <LogoContainer
                      brand={logo || ''}
                      color={'background-aware'}
                      aspectRatio={'3:2'}
                      width={90}
                      height={60}
                      alignment={'Center Left'}
                      isLink={false}
                      ariaRole="img"
                    />
                  )}
                </div>
                <div className="d-flex mr-2">
                  {eyebrow && <Eyebrow text={eyebrow} variation={EyebrowEnum.Overlay} />}
                  <span className={clsx('col-3')}></span>
                </div>
                <div className="d-flex mt-2">
                  <h4 className="card-text header">{title}</h4>
                  <span className={clsx('col-3')}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Button>
    </StyledSuitesCard>
  );
};
